import { createContext } from "react"
import { InteractiveState } from "./types"

export const InteractiveContext = createContext<InteractiveState>({
  isDisabled: false,
  isHovered: false,
  isPressed: false,
  isFocused: false,
})
